import React from 'react';
import { useScreenInit } from '../useScreenInit.js';
import { Hero } from '../components/home/Hero';
import { IssueSelector } from '../components/home/IssueSelector';
import { WhyContact } from '../components/home/WhyContact';
import { TrustBar } from '../components/home/TrustBar';
import { HowWeWork } from '../components/home/HowWeWork';
import { FeaturedServices } from '../components/home/FeaturedServices';
import { AudiencePathways } from '../components/home/AudiencePathways';
import { Testimonials } from '../components/home/Testimonials';
import { Guides } from '../components/home/Guides';
import { HomeFAQ } from '../components/home/HomeFAQ';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  useScreenInit();
  return <div className="w-full bg-cream" data-id="element-514">
      <Hero data-id="element-515" />
      <IssueSelector data-id="element-516" />
      <WhyContact data-id="element-517" />
      <TrustBar data-id="element-518" />
      <HowWeWork data-id="element-519" />
      <FeaturedServices data-id="element-520" />
      <AudiencePathways data-id="element-521" />
      <Testimonials data-id="element-522" />
      <Guides data-id="element-523" />
      <HomeFAQ data-id="element-524" />
      <FinalCTA data-id="element-525" />
    </div>;
}